export default __webpack_public_path__ + "static/media/cover.c04fd451.png";